/**
 * Глобальный fallback-пул русских дистракторов для MCQ-упражнения, когда
 * у карточки нет своих selection_options (MANUAL или старые LLM-карточки до
 * фичи selection_options). Подбираются «правдоподобно похоже на правду» —
 * существительные/глаголы из разных тем, чтобы вариант ответа не отвергался
 * с первого взгляда.
 */
export const DISTRACTORS = [
  'ПРИОБРЕТАТЬ',
  'БЕГЛЫЙ',
  'ИДИОМА',
  'НЮАНС',
  'КОНТЕКСТ',
  'БУКВАЛЬНЫЙ',
  'ОШЕЛОМЛЯТЬ',
  'ЛЕЛЕЯТЬ',
  'ЗАВИСТЬ',
  'ГИПОТЕЗА',
  'СТРУКТУРА',
  'РАЗВЁРТЫВАТЬ',
  'ЗАПРОС',
  'АЛГОРИТМ',
  'ЖАНР',
  'НАСЛЕДИЕ',
  'ПЕРЕВОДИТЬ',
  'В ВОСТОРГЕ',
  'ОТКРЫВАТЬ',
  'ИСКАТЬ',
  'ВСТРЕЧАТЬ',
];
